import React from 'react';
import { createIcon } from 'components/shared/SVGIcon';

const CloseIcon = createIcon(
  'Close',
  <path d="M18.6894198,5.32119833 C18.2753129,4.90709139 17.6063709,4.90709139 17.1922639,5.32119833 L12,10.5028441 L6.80773606,5.3105802 C6.39362912,4.89647327 5.72468714,4.89647327 5.3105802,5.3105802 C4.89647327,5.72468714 4.89647327,6.39362912 5.3105802,6.80773606 L10.5028441,12 L5.3105802,17.1922639 C4.89647327,17.6063709 4.89647327,18.2753129 5.3105802,18.6894198 C5.72468714,19.1035267 6.39362912,19.1035267 6.80773606,18.6894198 L12,13.4971559 L17.1922639,18.6894198 C17.6063709,19.1035267 18.2753129,19.1035267 18.6894198,18.6894198 C19.1035267,18.2753129 19.1035267,17.6063709 18.6894198,17.1922639 L13.4971559,12 L18.6894198,6.80773606 C19.0929086,6.40424725 19.0929086,5.72468714 18.6894198,5.32119833 Z" />
);

export default CloseIcon;
